<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.fornecedor"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(cnpj)="{item}">
                <template v-if="item.cnpj">
                    {{item.cnpj | cnpj}}
                </template>
            </template>

            <template v-slot:cell(conectasusFornecedorNomeFantasia)="{item}">
                <template v-if="item.conectasusFornecedorNomeFantasia">
                    {{ item.conectasusFornecedorNomeFantasia }}
                </template>

                <rkm-button
                    v-else
                    @click="$refs.ModalVinculoConectaSusFornecedor.open(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-fornecedor"
                    color="primary"
                    small
                >
                    Vincular fornecedor
                </rkm-button>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-fornecedor"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-web-service-almoxarifado-cliente-fornecedor"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalVinculoConectaSusFornecedor
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalVinculoConectaSusFornecedor"
        />
    </div>
</template>

<script>
// Components.
import ModalVinculoConectaSusFornecedor from './components/vinculo-conecta-sus-fornecedor/Modal'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import {error, repository} from '@/mixins'

export default {
    components: {ModalVinculoConectaSusFornecedor},
    created() {
        this.repositories = {
            fornecedor: this.getConectaSusRepository('webService.almoxarifado.cliente.fornecedor'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'fornecedor.nome', searchable: true, sortable: true},
            {key: 'cnpj', label: 'CNPJ', name: 'fornecedor.cnpj', searchable: true, sortable: true},
            {
                key: 'conectasusFornecedorNomeFantasia',
                label: 'Fornecedor (ConectaSUS)',
                name: 'conectasusFornecedor.nomeFantasia',
                searchable: true,
                sortable: true
            },
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    filters: {
        cnpj: formats.formatCnpj,
    },
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-almoxarifado-cliente-fornecedor-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.fornecedor.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o fornecedor?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>